import Cookies from 'js-cookie'

export function getToken () {
  return undefined !== Cookies.get('token') ? Cookies.get('token') : ''
}

export function setToken (token) {
  return Cookies.set('token', token)
}

export function removeToken () {
  return Cookies.remove('token')
}

export function getIsAdmin () {
  return undefined !== Cookies.get('isAdmin') && Cookies.get('isAdmin') === true
}

export function setIsAdmin (token) {
  return Cookies.set('isAdmin', token)
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js